import React, { useState, useEffect } from 'react'
import { LoginAgendaTe } from './Componentes/LoginComponents/LoginAgendaTe'
import { RegistraAgendaTe } from './Componentes/LoginComponents/RegistraAgendaTe'
import LandingAgendaTe from './Componentes/LandingElements/LandingAgendaTe'
import { useSearchParams } from "react-router-dom";
import { ENUM_QUERY_PARAMS } from './utils/Enumerados';

const AgendatePublicZone = () => {

    useEffect(() => {
        if (searchParams.has(ENUM_QUERY_PARAMS.USUARIO_ACTION_PASS_ID) || searchParams.has(ENUM_QUERY_PARAMS.LOGOUT)) {
            setSelectActionPublicZone('LOGIN_AGENDATE')
        }
    }, [])

    const [searchParams] = useSearchParams();

    const [selectActionPublicZone, setSelectActionPublicZone] = useState('LANDING_AGENDATE')

    const componentValidated = () => {
        switch (selectActionPublicZone) {
            case 'LOGIN_AGENDATE':
                return (
                    <LoginAgendaTe setSelectActionPublicZone={setSelectActionPublicZone} />
                )
            case 'REGISTRA_AGENDATE':
                return (
                    <RegistraAgendaTe setSelectActionPublicZone={setSelectActionPublicZone} />
                )
            case 'LANDING_AGENDATE':
                return (
                    <LandingAgendaTe setSelectActionPublicZone={setSelectActionPublicZone} />
                )
            default:
                return (
                    <></>
                )
        }
    }

    return (
        <>
            {
                componentValidated()
            }
        </>
    )
}

export default AgendatePublicZone